/**
 * CORE-964 — показ денежных сумм реферальной программы.
 *
 * Бэкенд считает и хранит деньги в целых минорных единицах (копейки, центы) —
 * так устроен ledger, и это единственный способ не получить расхождение в
 * копейку, которое потом невозможно объяснить. Здесь минорные единицы
 * превращаются в строку для человека, и ровно здесь заканчивается вся
 * денежная арифметика фронта: складывать, вычитать и считать проценты от
 * этих чисел на клиенте нельзя — это делает сервер.
 */

const MINOR_UNITS_PER_MAJOR = 100;

/** Валюты, которые бэкенд может прислать: RUB для RU-контура, USD/EUR для остальных. */
const SYMBOLS: Record<string, string> = {
    RUB: '₽',
    USD: '$',
    EUR: '€',
};

export function currencySymbol(currency: string): string {
    return SYMBOLS[currency?.toUpperCase()] ?? currency ?? '';
}

/**
 * Сумма для показа. Копейки скрываются, когда их нет: «1 200 ₽» читается
 * лучше, чем «1 200,00 ₽», а вот «1 200,50 ₽» терять нельзя.
 */
export function formatReferralMoney(amountMinor: number, currency: string, locale = 'ru-RU'): string {
    const safe = Number.isFinite(amountMinor) ? amountMinor : 0;
    const negative = safe < 0;
    const abs = Math.abs(safe);

    const major = Math.trunc(abs / MINOR_UNITS_PER_MAJOR);
    const minor = abs % MINOR_UNITS_PER_MAJOR;

    const majorText = major.toLocaleString(locale);
    const value = minor === 0
        ? majorText
        : `${majorText},${minor.toString().padStart(2, '0')}`;

    return `${negative ? '−' : ''}${value} ${currencySymbol(currency)}`.trim();
}
